type SearchableProject = {
    name?: string | null;
    interest_description?: string | null;
    project_keywords?: Array<{ keyword?: string | null }>;
    project_category_interests?: Array<{
        category?: { name?: string | null; code?: string | null } | null;
    }>;
};

function normalizeSearch(value: string): string {
    return value.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().trim();
}

// Search a normalized projection only. Never modify user-authored project data.
export function filterDashboardProjects<T extends SearchableProject>(projects: T[], query: string): T[] {
    const terms = normalizeSearch(query).split(/\s+/).filter(Boolean);
    if (!terms.length) return projects;

    return projects.filter((project) => {
        const searchable = normalizeSearch([
            project.name,
            project.interest_description,
            ...(project.project_keywords ?? []).map(({ keyword }) => keyword),
            ...(project.project_category_interests ?? []).flatMap(({ category }) => [
                category?.name, category?.code,
            ]),
        ].filter(Boolean).join(' '));
        return terms.every((term) => searchable.includes(term));
    });
}
